enum CardAction {
  REPLACE = 'REPLACE',
  REISSUE = 'REISSUE',
  BLOCK = 'BLOCK',
  UNBLOCK = 'UNBLOCK',
}

export default CardAction;
